import { apiClient } from "../api/apiclient"

export const getGender = (token) =>
    apiClient.get("/gender", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getCasteCategory = (token) =>
    apiClient.get("/castecategory", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getReligion = (token) =>
    apiClient.get("/religion", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getNationality = (token) =>
    apiClient.get("/nationality", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getMaritalData = (token) =>
    apiClient.get("/maritalstatus", {
        headers: { Authorization: `Bearer ${token}`},
    });


export const getBloodGroup = (token) =>
    apiClient.get("/bloodGroup", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getProgramme = (token) =>
    apiClient.get("/Programmes", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getStudentDetails = (token, studentId) =>
    apiClient.get(`/student-details?studentId=${studentId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });



export const getLastQualifyingDetails = (token, studentId, courseId) =>
    apiClient.get(
        "/last-qualifying-exam/course",
        {
            headers: { Authorization: `Bearer ${token}` },
            params: { studentId, courseId }
        }
    );

export const getUniversityboard = (token) =>
    apiClient.get("/universityandboard", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const getDocumentByStudentID = (token, studentId, courseId) =>
    apiClient.get("/document/course", {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId, courseId },
    }
    );

export const updateLastQualifying = (requestBody, token, studentId) =>
    apiClient.put("/last-qualifying-exam", requestBody, {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId },
    }
    );

export const updatestudentdetails = (requestBody, token, studentId) =>
    apiClient.put("/student-details", requestBody, {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId },
    }
    );

    export const fetchStudentPhoto = (token, studentId) =>
        apiClient.get("/getphoto", {
            headers: { Authorization: `Bearer ${token} `},
            params: { studentId },
            responseType: 'blob'
        });
    
    export const fetchStudentSign = (token, studentId) =>
        apiClient.get("/getsign", {
            headers: { Authorization: `Bearer ${token}` },
            params: { studentId },
            responseType: 'blob'
        });
    
    export const fetchSubjectbyStudentID = (token, studentId, courseId) =>
        apiClient.get("/subject-preference/course", {
            headers: { Authorization: `Bearer ${token}` },
            params: { studentId, courseId }
        });